import './pullToRefresh.scss';

export default function ($q, $translate, $timeout) {
  const pullToRefresh = require('pulltorefreshjs');

  return {
    restrict: 'A',

    scope: {pullToRefresh: '&'},

    link: function (scope, elem) {
      let refresher;
      let instructionsPullToRefresh;
      let instructionsReleaseToRefresh;
      let instructionsRefreshing;

      initLiterals(init);

      scope.$on('$destroy', ()=> {
        refresher.destroy();
      });

      function initLiterals(cb) {
        $q.all([
          $translate('GLOBALS.PULL_TO_REFRESH.FIRST').then(translation => instructionsPullToRefresh = translation),
          $translate('GLOBALS.PULL_TO_REFRESH.SECOND').then(translation => instructionsReleaseToRefresh = translation),
          $translate('GLOBALS.PULL_TO_REFRESH.THIRD').then(translation => instructionsRefreshing = translation)
        ]).then(() => {
          cb();
        });
      }

      function init() {
        refresher = pullToRefresh.init({
          mainElement: elem[0],
          onRefresh: ()=> $timeout(()=> scope.pullToRefresh()),
          shouldPullToRefresh,
          distThreshold: 50,
          instructionsPullToRefresh,
          instructionsReleaseToRefresh,
          instructionsRefreshing
        });
      }

      function shouldPullToRefresh() {
        return isOnTop() && !isModalOpen();
      }

      function isOnTop() {
        return (window.pageYOffset === 0 || window.scrollY === 0);
      }

      function isModalOpen() {
        return document.body.className.indexOf('modal-open') > -1;
      }
    }
  };
}



// WEBPACK FOOTER //
// ./client/app/common/directives/pullToRefresh.js